import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagEnabled: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-enabled',
		defaultMessage: '‘{displayName}’ is on',
		description: 'Indication that the named feature flag is on (enabled).',
	},
	flagDisabled: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flag-disabled',
		defaultMessage: '‘{displayName}’ is off',
		description: 'Indication that the named feature flag is off (disabled).',
	},
	flagsHidden: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.multiple-flags.tooltip-content.flags-hidden',
		defaultMessage: '+ {hiddenFlagsCount} more',
		description:
			'Indicates that there are more feature flags that are not displayed here due to space constraints.',
	},
});
